import React from 'react'
import { Button, Typography } from '@telavita-core/react-design-kit'

import { ApproachCard } from 'components/ApproachCard'
import ModalGeneric from '../ModalGeneric'

import { therapyApproachesList } from './utils/therapyApproachesList'
import { useRef } from 'react'

interface TherapyApproachModalProps {
  onClose: () => void
}

export const TherapyApproachModal = ({ onClose }: TherapyApproachModalProps): JSX.Element => {
  const approachesContainer = useRef<HTMLDivElement>(null)
  const itemsRef = useRef<HTMLDivElement[]>([])

  const scrollIntoElement = (elemIndex: number) => {
    const element = itemsRef.current[elemIndex]
    const y = element.getBoundingClientRect().top - element.offsetHeight - 10
    approachesContainer.current.scrollTop += y
  }

  return (
    <ModalGeneric
      modalTitle={
        <>
          Abordagem terapêutica: <br /> descubra qual é a melhor para você
        </>
      }
      onCloseModal={onClose}
      customClassName='ApproachesModal'
      containerCustomClassName='ApproachesModalContainer'
      topbarCustomClassName='ApproachesModalTopbar'
      titleCustomClassName='ApproachesModalTitle'
      containerRef={approachesContainer}
      genericModalId='ModalGeneric__Modal__TherapyApproach'
    >
      <div className='ApproachesModal__Sidebar'>
        <Typography variant='content2'> 
          Selecione:
        </Typography>
        <ul className='ApproachesModal__ApproachesList'>
          {therapyApproachesList.map((approach, index) => (
            <li key={approach.name}>
              <Button
                variant='text'
                customClassName='ApproachesModal__ApproachesList__Button'
                onClick={() => scrollIntoElement(index)}
              >
                {approach.name}
              </Button>
            </li>
          ))}
        </ul>
      </div>
      <div className='ApproachesModal__Container'>
        <div className='ApproachesModal__DescriptionContainer'>
          {therapyApproachesList.map((approach, index) => (
            <ApproachCard
              key={approach.name}
              name={approach.name}
              description={approach.description}
              ref={(elem: HTMLDivElement) => itemsRef.current[index] = elem}
            />
          ))}
        </div>
      </div>
    </ModalGeneric>
  )
}